export const inputStyle = {
  width: '100%',
  height: '100%',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px',
  paddingLeft: '54px',
  fontFamily: 'letteratextllRegular',
};
